/* eslint-disable no-nested-ternary */

const BLUE = '#2563eb';
const SLATE = '#020617';
const OFF_WHITE = '#f1f5f9';
export default {
  buttonStyles: {
    // eslint-disable-next-line no-unused-vars
    customButtonStyles: (vm) => {
      return {
        'border-radius': vm.card ? '8px' : '50px',
        background:
          !vm.disabled && !vm.selected && !vm.hover
            ? 'white'
            : vm.disabled
            ? `${OFF_WHITE}!important`
            : vm.variant
            ? `${BLUE}!important`
            : `${BLUE}!important`,
        color: !vm.disabled && !vm.selected && !vm.hover && BLUE,
        border: '',
      };
    },
    customButtonClasses: (vm) => {
      return {
        'secondary white--text font-weight-bold': vm.variant && !vm.disabled,
      };
    },
  },
  theme: {
    anchor: '#1e88e5' /* blue -- info */,
    accent: {
      base: '#1e88e5' /* blue -- info */,
      darken1: '#979797' /* grey */,
    },
    info: {
      base: '#1e88e5' /* blue */,
      //   darken1: '#7460ee' /* indigo */,
      //   darken2: '#563dea' /* dark indigo */,
      //   darken3: '#6f42c1' /* BLUE */,
    },
    primary: {
      base: BLUE /* BLUE */,
      //   lighten1: '#6c757d' /* lighter grey for text and menu hover */,
      //   lighten2: '#FFFFFF' /* white */,
    },
    secondary: {
      base: BLUE,
      // base: '#6c757d' /* grey */,
      // lighten1: '#6c757d' /* lighter grey for text and menu hover */,
      lighten1: '#f5f5f5' /* light grey */,
      darken1: '#6c757d',
    },
    background: '#ffffff' /* light grey */,

    /**
     * The global custom styles field will apply the following styles globally
     * to an entire pageflow
     */

    customGlobalStyles: {
      color: SLATE,
      'font-family': "'Montserrat' sans-serif!important",
    },

    /**
     * If there is a stylesheet in /styles, it will be applied to this pageflow.
     */

    customStyleSheet: 'sentry',
  },
};
